// biome-ignore-all assist/source/useSortedKeys: manual sorting for this file is better for readability

const defaultTheme: UTheme = 'pro_layout';

/**
 * Example of usage "themeList"
{
  name: 'my_theme', // folder name in src/theme which contains vars.json and assets/index.scss
  title: 'My theme',
  inherit: 'another_theme', // optional, if specified, the theme will inherit styles and vars.json from another theme
  settings: {
    isLightTheme: true,
  },
},
 */

/**
 * Example of vars.json
 {
   "bg-active-gradient": "radial-gradient(50% 1007.51% at 51.11% 50%, #2F3EC8 0%, #637AF4 100%)",
   "bg-main-elements": "#242A37",
   "bg-main-layouts": "#1A1E27",
   "bg-mobile-menu-head": "#E9E9F0",
   "border-radius-inner": "3px",
   "border-radius-outer": "6px",
   "text-active": "#6178F3",
   "text-default": "#9092B2",
 }
 */

const themeList: IThemeItem[] = [
  {
    name: 'dexsport',
    title: 'Dexsport',
  },
] as const;

const themeIsValid = (theme: UTheme): theme is UTheme => {
  return !!themeList.find(({ name }) => name === theme);
};

export interface IThemeItem {
  name: string;
  title: string;
  inherit?: UTheme | UTheme[];
  settings?: {
    isLightTheme?: boolean;
    [key: string]: unknown;
  };
}

export type UTheme = (typeof themeList)[number]['name'];

export { themeList, themeIsValid, defaultTheme };
